import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'dateFormatLocal',
})
export class DateFormatPipe implements PipeTransform {
  transform(value: any) {
    let datePipe = new DatePipe('en-US');
    value = datePipe.transform(value, 'MMM d, y, h:mm:ss a');
    return value;
  }
}
